// extracted by mini-css-extract-plugin
export default {"loader_container":"Load_loader_container__LC6VB","loader":"Load_loader__yFxHX"};